import zhHans from './zh-Hans.json'
import mn from './mn.json'
export default {
	'zh': zhHans,
	mn
}



// WEBPACK FOOTER //
// ./src/locale/index.js